const DEVICE_TIME_ZONE = "Asia/Kolkata";

// Raw readings are ISO UTC. Hourly SQL buckets have no zone suffix but are
// produced by the UTC database, so treat their start time as UTC as well.
const parseLevelTransmitterTime = (value) => {
  if (value == null || value === "") return null;
  const text = String(value);
  if (/^\d{4}-\d{2}(?:-\d{2})?$/.test(text)) return null;
  const utcValue = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(?::\d{2})?$/.test(text)
    ? `${text.replace(" ", "T")}Z`
    : text;
  const date = new Date(utcValue);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatLevelTransmitterDateTime = (value) => {
  const date = parseLevelTransmitterTime(value);
  if (!date) return value == null || value === "" ? "--" : String(value);
  const parts = Object.fromEntries(new Intl.DateTimeFormat("en-GB", {
    timeZone: DEVICE_TIME_ZONE,
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23",
  }).formatToParts(date).map(({ type, value: part }) => [type, part]));
  return `${parts.day}-${parts.month}-${parts.year} ${parts.hour}:${parts.minute}:${parts.second}`;
};

export const formatLevelTransmitterDashboardDateTime = (value) => {
  const date = parseLevelTransmitterTime(value);
  if (!date) return "--";
  return `${date.toLocaleDateString("en-GB", { timeZone: DEVICE_TIME_ZONE })} ${date.toLocaleTimeString("en-US", { timeZone: DEVICE_TIME_ZONE, hour12: true })}`;
};

export const formatLevelTransmitterHistoryRows = (rows = []) => rows.map((row) => ({
  ...row,
  date_time: formatLevelTransmitterDateTime(row.date_time),
  ...(row.date_column != null
    ? { date_column: formatLevelTransmitterDateTime(row.date_column) }
    : {}),
}));
